var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.extras.groupDownloadDisplay && _vm.extras.groupDownloadDisplay.display == 1
  )?_c('div',{staticClass:"m-load top-nav m-journalism new",style:({
    background:
      _vm.extras.downloadBg.colorOrBg == 'color'
        ? _vm.extras.downloadBg.color
        : 'url(' + _vm.extras.downloadBg.src + ')',
  }),attrs:{"id":"download"}},[(_vm.extras.downloadTitle.display == 1)?_c('WapTitle',{attrs:{"title":_vm.extras.downloadTitle.mainTitle || _vm.title,"en":_vm.extras.downloadTitle.subTitle || 'DOWNLOAD',"extras":_vm.extras}}):_vm._e(),(_vm.folderList.length > 1)?_c('div',{staticClass:"m-tab-list-new-wap",class:'tab-length' + _vm.folderList.length},_vm._l((_vm.folderList),function(item,index){return _c('div',{key:index,staticClass:"tab-new",class:{
        active: item.id == _vm.currentId,
      },on:{"click":function($event){return _vm.columnClick(item)}}},[_vm._v(" "+_vm._s(item.name)+" "),_c('div',{staticClass:"underline",attrs:{"data-v-2a8f24dd":""}})])}),0):_vm._e(),(_vm.fileList && _vm.fileList.length > 0)?_c('div',{staticClass:"g-download-list-new-wap",class:_vm.extras.downloadStyle.style == '1' ? 'single' : ''},_vm._l((_vm.fileList),function(item,index){return _c('div',{key:index,staticClass:"item",style:({
        background:
          _vm.extras.downloadItemBg.colorOrBg == 'color'
            ? _vm.extras.downloadItemBg.color
            : 'url(' + _vm.extras.downloadItemBg.src + ')',
      })},[_c('img',{attrs:{"src":item.iconMapRealPath
            ? item.iconMapRealPath
            : require('@/assets/images/defaultNew.jpg'),"alt":""},on:{"click":function($event){return _vm.see(item)}}}),(_vm.extras.downloadItenTitle.display == 1)?_c('div',{staticClass:"name",style:({
          color:
            _vm.extras.downloadItenTitle.text == 'custom'
              ? _vm.extras.downloadItenTitle.fontColor
              : '',

          'font-style':
            _vm.extras.downloadItenTitle.text == 'custom'
              ? _vm.extras.downloadItenTitle.fontTilt == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-Weight':
            _vm.extras.downloadItenTitle.text == 'custom'
              ? _vm.extras.downloadItenTitle.fontWeight == 'on'
                ? 'bolder'
                : ''
              : '',
        }),on:{"click":function($event){return _vm.see(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")]):_vm._e(),(_vm.extras.downloadButton.display == 1)?_c('div',{staticClass:"button",style:({
          //                   'width':extras.downloadButton.layout == 'custom'?extras.downloadButton.btnWidth+'%':'',
          background:
            _vm.extras.downloadButton.layout == 'custom'
              ? _vm.extras.downloadButton.colorOrBg == 'color'
                ? _vm.extras.downloadButton.color
                : 'url(' + _vm.extras.downloadButton.src + ')'
              : '',
          color:
            _vm.extras.downloadButton.style == 'custom'
              ? _vm.extras.downloadButton.fontColor
              : '',

          'font-style':
            _vm.extras.downloadButton.style == 'custom'
              ? _vm.extras.downloadButton.fontTilt == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-Weight':
            _vm.extras.downloadButton.style == 'custom'
              ? _vm.extras.downloadButton.fontWeight == 'on'
                ? 'bolder'
                : ''
              : '',
          'border-width': _vm.extras.downloadButton.border == 'show' ? '' : 0,
        }),on:{"click":function($event){return _vm.download(item)}}},[(_vm.extras.downloadButtonText.icon != 'hide')?_c('span',{staticClass:"icontemp download-a"}):_vm._e(),_vm._v(" "+_vm._s(_vm.extras.downloadButtonText.text)+" ")]):_vm._e()])}),0):_vm._e(),(_vm.fileList && _vm.fileList.length == 0)?_c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require('@/assets/images/nodata.png')}}),_c('div',{staticClass:"no-data-text"},[_vm._v("暂无数据")])]):_vm._e(),_c('vodal',{attrs:{"show":_vm.show,"animation":"zoom"},on:{"hide":function($event){_vm.show = false}}},[(_vm.Sent)?_c('div',{staticClass:"mail-box"},[_c('div',{staticClass:"title"},[_vm._v("请输入您的邮箱")]),_c('div',{staticClass:"mail",staticStyle:{"height":"7vw"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mailbox),expression:"mailbox"}],attrs:{"type":"text","placeholder":"请输入您的邮箱"},domProps:{"value":(_vm.mailbox)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mailbox=$event.target.value}}}),_c('span',[_vm._v(_vm._s(_vm.tip))])]),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.determine()}}},[_vm._v("确定")])]):_c('div',{staticClass:"success"},[_c('p',[_vm._v("已下载成功")]),_c('div',[_vm._v("请稍后查看您的邮箱")])])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }